import React from "react";
import { Rating, Star } from "@smastrom/react-rating";


const RatingView = ({ reviewCount, reviewAverage }) => {
  return (
    <div className="flex items-center space-x-1">
      <Rating
        style={{ maxWidth: 80 }}
        value={Number(reviewAverage?.value || 0)}
        readOnly
        itemStyles={{
          itemShapes: Star,
          activeFillColor: "#FFC83D",
          inactiveFillColor: "#EEEEEE",
          // itemStrokeWidth: 2,
          // activeStrokeColor: "#000",
        }}
      />
      <h4 className="w-fit text-xs md:text-sm font-normal">({reviewCount?.value || 0}<span className="hidden md:inline"> reviews</span>)</h4>
    </div>
  );
};

export default RatingView;
